import React from "react";

import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from "../../../../../../../ui/Button";
import TextField from "@material-ui/core/TextField";

import DigitalMaterials from "./DigitalMaterials";

const DialogTitle = withStyles(theme => ({
  root: {
    color: "#778899",
    "& > h2": {
      fontSize: 12
    }
  }
}))(MuiDialogTitle);

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    display: "flex"
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: "16px",
    "& > button:first-of-type": {
      marginRight: 4
    }
  }
}))(MuiDialogActions);

const holdingForm = [
  {
    id: 1,
    description: "Аудиторно"
  },
  {
    id: 2,
    description: "Онлайн"
  }
];

export default function LessonDialog({
  showLessonDialog,
  closeLessonDialog,
  type,
  title,
  allLessonType,
  lesson,
  changeLesson,
  changeLessonConduct,
  changeLessonType,
  activeThemeId,
  activeLessonId,
  addModuleLesson,
  updateModuleLesson
}) {
  const addLesson = () => {
    const moduleLesson = {
      themeId: activeThemeId,
      main: {
        number: lesson.main.number,
        name: lesson.main.name,
        type: lesson.main.type,
        conduct: lesson.main.conduct,
        requirements: lesson.main.requirements
      },
      content: {
        description: lesson.description
      },
      sites: [1]
    };
    addModuleLesson(moduleLesson);
    closeLessonDialog();
  };

  const updateLesson = () => {
    const moduleLesson = {
      main: {
        number: lesson.main.number,
        name: lesson.main.name,
        type: lesson.main.type,
        conduct: lesson.main.conduct,
        requirements: lesson.main.requirements
      },
      content: {
        description: lesson.description
      },
      sites: [1]
    };
    updateModuleLesson(activeLessonId, moduleLesson);
    closeLessonDialog();
  };

  /*   const addDigitalMaterails = () => {
    const values = [...ability];
    values.unshift({
      url: "ixbt.com",
      lessonId: 1,
      name: "IXBT",
      id: 1
    });
    setMaterials(values);
  }; */

  return (
    <Dialog open={showLessonDialog}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid
            container
            justify="space-between"
            style={{ marginBottom: "10px" }}
          >
            <Grid item xs={4}>
              <Autocomplete
                options={allLessonType}
                disableClearable
                getOptionLabel={option => (option.name ? option.name : option)}
                value={
                  allLessonType.find(item => item.id === lesson.main.type) || ""
                }
                onChange={(event, item) => changeLessonType(event, item.id)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Вид"
                    InputLabelProps={{
                      shrink: true
                    }}
                    fullWidth
                    required
                  />
                )}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                name="number"
                required
                label="Номер"
                value={lesson.main.number}
                onChange={changeLesson}
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                options={holdingForm}
                disableClearable
                getOptionLabel={option =>
                  option.description ? option.description : option
                }
                value={
                  holdingForm.find(item => item.id === lesson.main.conduct) ||
                  ""
                }
                onChange={(event, item) =>
                  changeLessonConduct(event, item.id) || ""
                }
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Форма проведения"
                    InputLabelProps={{
                      shrink: true
                    }}
                    fullWidth
                    required
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <TextField
                name="name"
                required
                label="Наименование"
                value={lesson.main.name}
                onChange={changeLesson}
                style={{ width: "100%", marginBottom: "10px" }}
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                multiline
                name="requirements"
                label="Условия реализации"
                value={lesson.main.requirements}
                onChange={changeLesson}
                style={{ width: "100%", marginBottom: "10px" }}
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>
          </Grid>
          {/* <Grid container alignItems="baseline">
            <Grid item>
              <InfoField name="Цифровые учебные материалы" />
            </Grid>
            <Grid item>
              <Link
                variant="caption"
                onClick={() => console.log("Click Link")}
                style={{ color: "#007FBD", cursor: "pointer" }}
              >
                Добавить
              </Link>
            </Grid>
          </Grid> */}
          <DigitalMaterials />
        </Grid>
      </DialogContent>
      <Grid container justify="flex-end">
        <DialogActions>
          <Grid item>
            <Button onClick={() => closeLessonDialog()}>Отмена</Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => (type === "add" ? addLesson() : updateLesson())}
              color="green"
            >
              {type === "add" ? "Добавить" : "Обновить"}
            </Button>
          </Grid>
        </DialogActions>
      </Grid>
    </Dialog>
  );
}
